// src/components/Panel.jsx
import styled from "styled-components";

const InputBlock = styled.div`
  & > p {
    margin: 0;
    font-size: 12px;
    color: #000000;
    padding-bottom: 8px;
  }

  & > input {
    font-size: 14px;
    border: 1px solid #d1d3d4;
    border-radius: 4px;
    width: 100%;
    height: 41px;
    padding-inline-start: 12px;
    box-sizing: border-box;
  }

  & > select {
    font-size: 14px;
    border: 1px solid #d1d3d4;
    border-radius: 4px;
    width: 100%;
    height: 41px;
    padding-inline-start: 12px;
    box-sizing: border-box;
  }
`;
export default InputBlock;
